
import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { static_options } from '../lib/options';
import moment from 'moment';
import { filterOption } from '../lib/form_struct';
import { upload } from '@/util/oss';
import BatchModifying from './batch-modifying.vue';

const Hundun = namespace('Hundun');
const getUrl = require('baimahu/url-with-param');
const { VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  get_delivery_list: `${FCAPI}/boss/hundun/chuang/delivery`,
  edit_delivery_batch: `${FCAPI}/boss/hundun/chuang/delivery/batch/0`,
  user_define: `${FCAPI}/boss/hundun/chuang/custom/`,
  oss: `${FCAPI}/boss/aliyun/oss/policy`,
  edit_user_detail: `${FCAPI}/boss/hundun/user/attribute`,
  delete_tag: `${FCAPI}/boss/hundun/user/tag`,
  edit_info: `${FCAPI}/boss/hundun/company`
};
@Component({
  components: { BatchModifying }
})
export default class MissionDetail extends Vue {
  @Hundun.State('teacher_list') teacher_list!: any[]; //负责班主任
  @Hundun.State('tag_list') tag_list!: any; //标签
  // @Prop({ default: 1 }) download_sign!: any;
  @Prop({ default: () => [] }) search_info_list!: any;
  @Prop({ default: () => [] }) user_define_list!: Array<any>;

  @Watch('tag_list')
  tagListChange(newValue: any) {
    this.search_info_list.tag_id.bind.options = newValue.filter((item: any) => item.type == 1);
    this.search_info_list.tag_id_chuang.bind.options = newValue.filter((item: any) => item.type == 2);
  }

  @Inject('getCustomConfig')
  getCustomConfig: any;

  file_list: any;
  select_row_key = [];
  pagenation_info = { current: 0, limit: 0, total: 0 };
  static_options = static_options;
  data_list = [];
  is_loading = false;
  filterOption = filterOption;
  students_evaluation_img_list = [] as any;
  comment = '';
  select_id = 0;
  select_tag_id = 0;
  dialog_form_list = [] as any;
  modifying_dialog_visible = false;
  students_evaluation_visible = false;
  window = window as any;

  async getList(page = 1, download_sign = 0) {
    this.is_loading = true;
    const custom_list = this.user_define_list
      .filter((item: any) => item.value)
      .map((item: any) => ({
        id: item.id,
        type: item.type == 1 ? 'text' : 'select',
        value: item.value || ''
      }));
    const tag_id = (): any[] => {
      const tag_arr: any[] = [];
      if (this.search_info_list.tag_id.value) {
        this.search_info_list.tag_id.value.forEach((element: any) => {
          tag_arr.push(element[element.length - 1]);
        });
      }
      if (this.search_info_list.tag_id_chuang.value) {
        this.search_info_list.tag_id_chuang.value.forEach((element: any) => {
          tag_arr.push(element[element.length - 1]);
        });
      }
      return tag_arr.filter((item: any) => item != undefined);
    };
    const send_data = {
      industry: this.search_info_list.industry.value,
      source: this.search_info_list.source.value,
      source_desc: this.search_info_list.source_desc.value,
      tag_id: tag_id().join(','),
      name: this.search_info_list.name.value,
      mobile: this.search_info_list.mobile.value,
      corp_name: this.search_info_list.corp_name.value,
      corp_position: this.search_info_list.corp_position.value,
      income_min: this.search_info_list.income.value.first,
      income_max: this.search_info_list.income.value.second,
      fee_min: this.search_info_list.fee.value.first,
      fee_max: this.search_info_list.fee.value.second,
      // undelivered_module: this.search_info_list.undelivered_module.value.join(',') || undefined,
      teacher_id: this.search_info_list.teacher_id.value.join(',') || undefined,
      class_period: this.search_info_list.class_period.value,
      gender: this.search_info_list.gender.value,
      study_expectation: this.search_info_list.study_expectation.value,
      solution_progress: this.search_info_list.solution_progress.value,
      helping_progress: this.search_info_list.helping_progress.value,
      interview_records: this.search_info_list.interview_records.value,
      // cloth_size: this.search_info_list.cloth_size.value.join(',') || undefined,
      birthday_time_start: this.search_info_list.birthday_time.value[0] ? moment(this.search_info_list.birthday_time.value[0]).startOf('days').unix() : undefined,
      birthday_time_end: this.search_info_list.birthday_time.value[1] ? moment(this.search_info_list.birthday_time.value[1]).endOf('day').unix() : undefined,
      current: page,
      custom_list: encodeURIComponent(JSON.stringify(custom_list)),
      limit: 20,
      is_export: download_sign
    };
    console.log(download_sign);
    if (download_sign) {
      const url = getUrl(API.get_delivery_list, send_data);
      this.$axios.get(url).then((res) => {
        if (res.data.status === 200) {
          this.$message.info(res.data.data);
        } else {
          window.location.href = url;
        }
      });
    } else {
      const res = await this.$axios.get(API.get_delivery_list, { params: send_data });
      this.pagenation_info = { current: res.data.data.current, limit: res.data.data.limit, total: res.data.data.total };
      this.data_list = res.data.data.detail;
      this.data_list.forEach((item: any) => {
        item.undelivered_module = item.undelivered_module == 0 ? null : item.undelivered_module;
        item.gender = item.gender == 0 ? null : item.gender;
        item.birthday_time = item.birthday_time ? moment(item.birthday_time * 1000) : null;
        // item.cloth_size = item.cloth_size ? item.cloth_size.split(',') : [];
        item.teacher_id = item.teacher_id ? item.teacher_id.split(',').map(Number) : [];
        const custom_list = this.user_define_list.map((element: any) => ({ channel: 3, customconfig_id: element.id, custom_value: undefined }));
        item.custom.forEach((element: any) => {
          custom_list.forEach((val: any) => {
            if (element.customconfig_id == val.customconfig_id) val.custom_value = element.custom_value || undefined;
          });
        });
        item.custom_list = custom_list;
        item.user = item.user ? item.user : {};
        item.user.company_search = item.user.company_search ? item.user.company_search : {};
        item.chuang_user = item.chuang_user ? item.chuang_user : {};
        item.source = [];
        item.chuang_user.source = item.chuang_user?.source?.split(',').forEach((element: any) => {
          const source = static_options.source.find((val: any) => val.value == element)?.label;
          if (source) item.source.push(source);
        });
        item.comment_image = item.comment_image == '' ? [] : item.comment_image.split(',').map((element: string) => ({ checked: false, url: element }));
        item.photos = item.photos == '' ? [] : item.photos.split(',');
        item.undelivered_module = item.undelivered_module && item.undelivered_module != '' ? item.undelivered_module.split(',').map(Number) : [];
      });
    }
    console.log(this.data_list);

    this.is_loading = false;
  }
  // 翻页
  paginationOption() {
    return {
      current: this.pagenation_info.current || 0,
      total: this.pagenation_info.total || 0,
      pageSize: this.pagenation_info.limit || 0,
      showTotal: () => `共${this.pagenation_info.total}条，每页${this.pagenation_info.limit}条`
    };
  }
  // 多选
  onSelectChange(select_row_key: any) {
    this.select_row_key = select_row_key;
    this.$emit('selectChange', select_row_key);
  }
  // 表格编辑
  async editTableValue(val: any, type: string, id: number) {
    // if (!val || val.length == 0) return;
    if (type == 'birthday_time') val = moment(val).unix() || 0;
    if (type == 'teacher_id' || type == 'undelivered_module') val = val.join(',');
    // if (type == 'cloth_size' || type == 'teacher_id') val = val.join(',');

    const send_data = { id: [id], [type]: val, cover_level: 1 };
    await this.$axios.put(`${API.edit_delivery_batch}`, send_data);
    this.$message.success('编辑成功！');
    this.getList(this.pagenation_info.current);
  }
  // 手机号
  formatMobile = (phone: any) => {
    const reg = /^(\d{3})\d{4}(\d{4})$/;
    phone = phone.toString().replace(reg, '$1****$2');
    return phone;
  };
  // 自定义字段编辑
  async userDefineTableValue(item: any, id: number) {
    // if (!item.custom_value) return;
    const res = await this.$axios.put(`${API.user_define}${id}`, item);
    if (res.data.status !== 200) return this.$message.error('编辑失败！');
    this.$message.success('编辑成功！');
    this.getList();
  }
  // 切换分页
  async changePage(page: any) {
    this.pagenation_info.current = page.current;
    this.getList(page.current);
  }

  async editTableValueUser(column: string, value: any, id: number) {
    const send_data = {
      column: column,
      value: value
    };
    const { data } = await this.$axios.put(`${API.edit_user_detail}/${id}`, send_data);
    if (data.status !== 200) return this.$message.error('编辑失败！');
    this.$message.success('编辑成功！');
    this.getList();
  }
  async editTableValueCompany(val: any, id: number) {
    const { data } = await this.$axios.put(`${API.edit_info}/${id}`, { highlights: val });
    if (data.status !== 200) return this.$message.error('编辑失败！');
    this.$message.success('编辑成功！');
    this.getList();
  }

  //添加标签
  addTag(record: any, type: number) {
    this.select_tag_id = record.user_id;
    this.dialog_form_list = [
      {
        tag_name: 'a-cascader',
        key: 'tag',
        label: '标签',
        value: undefined,
        bind: {
          options: this.tag_list.filter((item: any) => item.type == type),
          fieldNames: { label: 'tag_name', value: 'id', children: 'parent' },
          changeOnSelect: true,
          placeholder: '请选择'
        }
      }
    ];
    this.modifying_dialog_visible = true;
  }
  //删除标签
  async deleteTag(id: number) {
    const res: any = await this.$axios.delete(`${API.delete_tag}/${id}`);
    if (res.status == 200) {
      this.$message.success('删除成功');
      return;
    }
  }
  async tagOk(list: any) {
    console.log(123);
    const tag = list.find((item: any) => item.key == 'tag')?.value || undefined;
    const send_data = {
      column: 'tag',
      value: tag ? tag[tag.length - 1] : undefined
    };
    const res = await this.$axios.put(`${API.edit_user_detail}/${this.select_tag_id}?menu_id=${(window as any).route_menu_id}`, send_data);
    console.log(res);

    if (res.status !== 200 || res.data.status !== 200) return this.$message.error('编辑失败!');
    this.$message.success('编辑成功！');
    this.modifying_dialog_visible = false;
    this.getList(this.pagenation_info.current);
  }
  tagCancel() {
    this.modifying_dialog_visible = false;
    this.dialog_form_list.forEach((item: any) => (item.value = undefined));
  }

  async handleOk() {
    const send_data = { id: [this.select_id], comment: this.comment, comment_image: this.students_evaluation_img_list.map((item: any) => item.url).join(','), cover_level: 1 };
    const res = await this.$axios.put(`${API.edit_delivery_batch}`, send_data);
    console.log(res);
    this.$message.success('保存成功');
    this.students_evaluation_visible = false;
    this.getList();
  }
  handleCancel() {
    this.students_evaluation_visible = false;
    this.students_evaluation_img_list.forEach((element: any) => {
      element.checked = false;
    });
  }

  editStudent(val: any) {
    this.select_id = val.id;
    this.comment = val.comment;
    this.students_evaluation_img_list = val.comment_image;
    this.students_evaluation_visible = true;
    this.students_evaluation_img_list.forEach((element: any) => (element.checked = false));
  }

  onChange(val: any, index: number) {
    this.students_evaluation_img_list[index].checked = val.target.checked;
  }
  // 同学评价附件上传
  async upload(file: File) {
    const res = await upload(this.$axios, API.oss, file);
    if (res?.src) this.students_evaluation_img_list.push({ checked: false, url: res.src });
  }
  // 同学照片oss上传
  async studentImgOssUpload(file: File, record: any) {
    const res: any = await upload(this.$axios, API.oss, file);
    if (res?.src) {
      record.photos.push(res.src);
      this.studentImgUpload(record.id, record.photos);
    }
  }
  // 同学照片删除
  deleteIcon(list: any, record: any, index: number) {
    list.splice(index, 1);
    this.studentImgUpload(record.id, list || []);
  }
  // 同学照片上传
  async studentImgUpload(id: number, val: any) {
    const send_data = { id: [id], photos: val.join(','), cover_level: 1 };
    const { data } = await this.$axios.put(`${API.edit_delivery_batch}`, send_data);
    this.$message.success('编辑成功！');
    this.getList();
  }
  beforeUploadStudentImg(file: File, record: any) {
    this.studentImgOssUpload(file, record);
    return false;
  }

  beforeFileUpload(file: File) {
    this.upload(file);
    return false;
  }
  download(link: any[]) {
    if (link.length == 0) return this.$message.warn('请选择需要下载的图片！');
    link.forEach((item: any) => {
      let img = new Image();
      img.setAttribute('crossOrigin', 'Anonymous');
      img.onload = function () {
        let canvas = document.createElement('canvas');
        let context = canvas.getContext('2d');
        canvas.width = img.width;
        canvas.height = img.height;
        if (!context) return;
        context.drawImage(img, 0, 0, img.width, img.height);
        let url = canvas.toDataURL('images/jpg');
        let a = document.createElement('a');
        let event = new MouseEvent('click');
        a.download = '';
        a.href = url;
        a.dispatchEvent(event);
      };
      img.src = item.url + '?v=' + Date.now();
    });
  }
  deleteImg() {
    const num = this.students_evaluation_img_list.filter((item: any) => item.checked == true)?.length;
    if (!num) return this.$message.warn('请选择你需要删除的图片！');
    this.$confirm({
      title: '删除确认',
      content: `您已选中${num}个文件，确认删除？`,
      onOk: () => {
        this.students_evaluation_img_list = this.students_evaluation_img_list.filter((item: any) => item.checked == false);
      }
    });
    this.$forceUpdate();
  }
  imageBtn(type: number) {
    switch (type) {
      case 1:
        this.download(this.students_evaluation_img_list.filter((item: any) => item.checked == true));
        break;
      case 2:
        this.deleteImg();
        break;
      default:
        break;
    }
  }

  // 方案文件删除
  schemeFileClosed() {
    this.$message.success('删除成功!');
  }
  // 方案文件上传
  uploadSchemeFile() {
    this.$message.success('添加成功!');
  }
  async created() {
    await this.getCustomConfig();
    this.getList();
  }
}
